import type { RouteRecordRaw } from 'vue-router'

const systemRoutes: RouteRecordRaw[] = [
  {
    path: 'system',
    name: 'system',
    meta: {
      titleKey: 'routes.system.title',
      icon: 'Setting',
      helpKey: 'system'
    },
    redirect: { name: 'system-general' },
    children: [
      {
        path: 'general',
        name: 'system-general',
        component: () => import('@/views/system/SystemGeneral.vue'),
        meta: { titleKey: 'routes.system.general.title', helpKey: 'system_general' }
      },
      {
        path: 'sleep-report',
        name: 'system-sleep-report',
        component: () => import('@/views/system/SleepReportSettings.vue'),
        meta: { titleKey: 'routes.system.sleep-report.title', helpKey: 'system_sleep_report' }
      },
      {
        path: 'sleep-report-template',
        name: 'system-sleep-report-template',
        component: () => import('@/views/system/SleepReportTemplate.vue'),
        meta: {
          titleKey: 'routes.system.sleep-report-template.title',
          helpKey: 'system_sleep_report_template'
        }
      },
      {
        path: 'sleep-report-backgrounds',
        name: 'system-sleep-report-backgrounds',
        component: () => import('@/views/system/SleepReportBackgrounds.vue'),
        meta: {
          titleKey: 'routes.system.sleep-report-backgrounds.title',
          helpKey: 'system_sleep_report_backgrounds'
        }
      },
      {
        path: 'third-party-credentials',
        name: 'system-third-party-credentials',
        component: () => import('@/views/system/ThirdPartyCredentials.vue'),
        meta: {
          titleKey: 'routes.system.third-party-credentials.title',
          helpKey: 'system_third_party_credentials'
        }
      },
      {
        path: 'localization',
        name: 'system-localization',
        component: () => import('@/views/system/Localization.vue'),
        meta: { titleKey: 'routes.system.localization.title', helpKey: 'localization' }
      },
      {
        path: 'help',
        name: 'system-help',
        component: () => import('@/views/system/HelpDocManage.vue'),
        meta: { titleKey: 'routes.system.help.title', helpKey: 'system_help' }
      },
      {
        path: 'release-notes',
        name: 'system-release-notes',
        component: () => import('@/views/system/ReleaseNotes.vue'),
        meta: { titleKey: 'routes.system.release-notes.title', helpKey: 'release_notes' }
      },
      {
        path: 'button-demo',
        name: 'system-button-demo',
        component: () => import('@/views/system/ButtonDemo.vue'),
        meta: { titleKey: 'routes.system.button-demo.title', helpKey: 'button_demo' }
      }
    ]
  }
]

export default systemRoutes
